<template>
    <div class='lands' :class="{ disabled: !actLpoIsDraft }">
      <table class='table-common'>
        <thead>
            <tr>
            <th rowspan="2">Квартал</th>
            <th rowspan="2">Выдел</th>
            <th rowspan="2">ЛП выдел</th>
            <th rowspan="2">Площадь ЛП выдела</th>
            <th rowspan="2">Повреждаемая порода</th>
            <th rowspan="2" colspan="5">Доля усыхающих и погибших деревьев, %</th>
            <th colspan="2">Степень повреждения полога, %</th>
            <th rowspan="2">Тип распределения поврежденных(погибших) деревьев</th>
            <th rowspan="2">Причины ослабления, повреждения</th>
          </tr>
          <tr>
            <th>дефолиация</th>
            <th>дехромация</th>
          </tr>
        </thead>
        <tbody>
            <template v-for="lpo in aviaResults">
                <tr>
                    <td rowspan="5">{{ lpo.area }}</td>
                    <td rowspan="5">{{ lpo.section }}</td>
                    <td rowspan="5">{{ lpo.section_lp }}</td>
                    <td rowspan="5"><input type='number' min="0" step="0.1" v-model.number='lpo.s_lp' /></td>
                    <td rowspan="5">
                        <p-multiselect
                            v-model="lpo.species_ids"
                            :options='remoteSpecies'
                            optionLabel='species'
                            dataKey='id'
                            display="chip"
                        />
                    </td>
                    <th>1</th>
                    <th>2</th>
                    <th>3</th>
                    <th>4</th>
                    <th>5а</th>
                    <td rowspan="5"><input type='number' min="0" max="100" step="1" v-model='lpo.defoliation_proc' oninput="if(value>100) value=100"/></td>
                    <td rowspan="5"><input type='number' min="0" max="100" step="1" v-model='lpo.dechromation_proc' oninput="if(value>100) value=100"/></td>
                    
                    <td rowspan="5">
                        <select v-model="lpo.distribution_type_id">
                        <option  v-for="item in remoteDistributionTypes" :key="item.id" :value="item.id">{{item.name}}</option>
                        </select>
                    </td>
                    <td rowspan="5">
                        <select v-model="lpo.reason_id">
                        <option v-for="item in remoteDamages" :key="item.id" :value="item.id">{{item.name}}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td v-for="item in [1,2,3,4,5]" :key="item">
                        <input type='number' min="0" max="100" step="1" :value="getStateCatValue(lpo.state_cats, item)" @input="setStateCatValue($event, lpo.state_cats, item)" />
                    </td>
                </tr>
                <tr>
                    <th>5б</th>
                    <th>5в</th>
                    <th>5г</th>
                    <th>5д</th>
                    <th>5е</th>
                </tr>
                <tr>
                    <td v-for="item in [6,7,8,9,10]" :key="item">
                        <input type='number' min="0" max="100" step="1" :value="getStateCatValue(lpo.state_cats, item)" @input="setStateCatValue($event, lpo.state_cats, item)" />
                    </td>
                </tr>
                <tr>
                    <td>Всего</td>
                    <td colspan="4" :class="{'red': sumCats(lpo) != 100, 'green': sumCats(lpo) == 100}">
                        {{sumCats(lpo)}}
                    </td>
                </tr>

            </template>
        </tbody>
      </table>    
      <input class="add-block-btn-row" @click="saveRecount(aviaResults)" type="button" value="Сохранить" :disabled="!needToSaveChanges"/>
    </div>
  </template>
  
  
  
  <script>
  import { mapState, mapActions } from "vuex";
  import requestToApi from "@/lib/requestToApi";
  const ROOT_API = process.env.VUE_APP_ROOT_API;
  
  const GET_AREAS = ROOT_API + "address/get_areas.php";
  const GET_SECTIONS = ROOT_API + "address/get_sections.php";
  const RECOUNT = ROOT_API + 'get_site_data/recount.php';
  
  export default {
  name: "AviaResults",
  components: {
  },
  data() {
    return {
      formValues: [],
      aviaResultsDB: [],
      aviaResults: [],
      addMode: false,
  
      forestry: null,
  
      selectedArea: null,
      selectedSection: null,
      isLpSection: false,
      selectedSectionLp: null,
  
      areaList: [],
      sectionList: [],
  
      selectedList: [],
  
      lpoToRemove: null,
      removeConfirmationOpen: false,
    };
  },
  created() {
    //this.deshifResults = a;
    //console.log(a);
    const catalogs = [ 'info_damage_reason_groups', 'info_distribution_types', 'info_mzl', 'info_mzl_prof'];
    this.loadCatalogs(catalogs);
    this.updateRemoteRecount();
    // for (let i = 0; i < this.aviaResultsDB.length(); i++) {
    //   this.formValues[i] = this.aviaResultsDB[i]
    // }
  },
  computed: {
    infoMzlAvia() {
        return this.infoMzl.filter(e => ["0", "370", "371"].includes(e.id)).map(e => {
            return {id: e.id, name: e.name}
        });
    },
    needToSaveChanges() {
        for (let i = 0; i < this.aviaResults.length; i++) {
          if (!this.objectsIsDeepEqual(this.aviaResults[i], this.aviaResultsDB[i])) {
            return true;
          }
        }
        return false;
    },
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },
    ...mapState("selectedLpo", {
      lpo: (state) => state.lpo,
    }),
    ...mapState("selectedLpo/recount", {
      remoteListRecount: (state) => state.remoteListRecount,
      remoteSpecies: state => state['speciesListTax'].map(e => {
        return {id: e.species_id, species: e.species}
      }),
    }),
    ...mapState("lpoData", {
      currentLpo: (state) => state.currentLpo,
      actLpoList: (state) => state.actLpoList,
    }),
    ...mapState({
      remoteDamages: state => state.catalogs.info_damage_reason_groups,
      remoteDistributionTypes: state => state.catalogs.info_distribution_types,
      infoMzl: state => state.catalogs.info_mzl,
      infoMzlProf: state => state.catalogs.info_mzl_prof
    })
  },
  watch: {
    selectedArea(area) {
      if (area) {
        this.getSectionList();
      }
    },
  },
  methods: {
    ...mapActions( ["loadCatalogs"]),
    ...mapActions("selectedLpo/recount", ["setRemoteListRecount"]),
    sumCats(lpo) {
      return lpo.state_cats.reduce((acc, item) => acc + item.trees_proc, 0);
    },
    getStateCatValue(state_cats, item) {
      let result = state_cats.find(e => e.state_cat_id == item);
      return result ? result.trees_proc: 0;
    },
    setStateCatValue(event, state_cats, item) {
      let newValue = parseInt(event.target.value);
      if (newValue > 100) { newValue = 100; }
      //const finded = state_cats.find(e => e.state_cat_id == item);
      const findedIndex = state_cats.findIndex(e => e.state_cat_id == item);
      if (newValue > 0) {
        if (findedIndex !== -1) {
          state_cats[findedIndex].trees_proc = newValue;
        } else {
          state_cats.push({"state_cat_id": item, "trees_proc": newValue});
        }
      } else {
        if (findedIndex !== -1) {
          state_cats.splice(findedIndex, 1);
        }
      }
    },
    async updateRemoteRecount() {
      let params = {
          url: RECOUNT,
          params: {lpo_id: this.lpo.lpo_id}
      }
      const data = await requestToApi(params);
      this.aviaResultsDB = JSON.parse(JSON.stringify(data));
      this.aviaResults = data;
    },
    async saveRecount(newRecount) {
      let params = {
          type: "post",
          url: RECOUNT,
          params: {lpo_id: this.lpo.lpo_id, recount: JSON.stringify(newRecount)}
      }
      const result = await requestToApi(params);
      // const result = await this.setRemoteListRecount(deshifResults);
      if (result.code == 0) {
        this.updateRemoteRecount();
      } else {
        alert("ошибка сохранения")
      }
    },
    objectsIsDeepEqual(object1, object2) {
      const objKeys1 = Object.keys(object1);
      const objKeys2 = Object.keys(object2);
  
      if (objKeys1.length !== objKeys2.length) return false;
  
      for (var key of objKeys1) {
        const value1 = object1[key];
        const value2 = object2[key];
  
        const isObjects = this.isObject(value1) && this.isObject(value2);
  
        if ((isObjects && !this.objectsIsDeepEqual(value1, value2)) ||
          (!isObjects && value1 !== value2)
        ) {
          return false;
        }
      }
      return true;
      
    },
    isObject(object) {
      return object != null && typeof object === "object";
    },
  }
  };
  </script>
  
  <style scoped src="@/style/wrapper.css"></style>
  <style scoped src="@/style/grid.css"></style>
  <style scoped src="@/style/input.css"></style>
  
  <style scoped>
  .disabled {
  pointer-events: none;
  opacity: 0.4;
  }
  .btn-row {
  margin-bottom: 20px;
  }
  
  .control-btn-row > button {
  margin-right: 10px;
  }
  
  .add-block {
  background-color: #eee;
  padding: 20px 20px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
  }
  
  .add-block-btn-row {
  margin-top: 10px;
  }
  
  .lpos-data {
  padding-top: 30px;
  }
  
  .title-block {
  font-size: 20px;
  font-family: "roboto black";
  
  margin-bottom: 40px;
  }
  
  .table-common td input {
  width: 45px;
  }
  .table-common td {
  padding: 2px;
  }
  .red {
  background: red;
  color:aliceblue;
  font-size: 16px;
  font-weight: 600;
  }
  .green {
  background: green;
  color:aliceblue;
  font-size: 16px;
  font-weight: 600;
  }

  
  </style>